export const BASE_PRODUCT_KEYS = {
  K1A: 'k1a',
  S3B_KIOSK: 's3b-kiosk',
};

export const PRODUCT_ALTERNATIVE_CATEGORIES = Object.freeze({
  KIOSK_MOUNT: 'kiosk_mount',
});
